import type { ConvergentMoteStatusProperties, MoteStatus } from '@mote/api'
import { pollForConvergentProperties } from '../async'

export interface WithMoteStatus {
  moteStatus: MoteStatus
}

export function shouldPollForReadyState(
  withMoteStatus: WithMoteStatus,
  shouldWaitForTranscription: boolean = true
): boolean {
  return (
    !withMoteStatus.moteStatus.isPlayable ||
    (shouldWaitForTranscription &&
      withMoteStatus.moteStatus.shouldPollForTranscription)
  )
}

export function getConvergentMoteStatusProperties(
  moteStatus: MoteStatus
): ConvergentMoteStatusProperties {
  return {
    isPlayable: moteStatus.isPlayable,
    transcriptDisplay: moteStatus.transcriptDisplay,
    transcriptPreview: moteStatus.transcriptPreview,
    shouldPollForTranscription: moteStatus.shouldPollForTranscription
  }
}

export async function pollForConvergentMoteStatusProperties<
  T extends (...args: any[]) => Promise<WithMoteStatus>
>(
  cb: T,
  shouldWaitForTranscription: boolean = true,
  timeoutRef?: (timeoutIdRef: number) => void
): Promise<Awaited<ReturnType<T>>> {
  return pollForConvergentProperties(
    cb,
    obj => shouldPollForReadyState(obj, shouldWaitForTranscription),
    timeoutRef
  )
}
